export default "__VITE_ASSET__Cssub2mS__"